var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPresent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-gift",
    "data-name": "Icon feather-gift",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M30,18V33H6V18",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_148",
    "data-name": "Trac\\xE9 148",
    d: "M3,10.5H33V18H3Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_149",
    "data-name": "Trac\\xE9 149",
    d: "M18,33V10.5",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_150",
    "data-name": "Trac\\xE9 150",
    d: "M18,10.5H11.25a3.75,3.75,0,0,1,0-7.5C16.5,3,18,10.5,18,10.5Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M18,10.5h6.75a3.75,3.75,0,1,0,0-7.5C19.5,3,18,10.5,18,10.5Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresent);
export default __webpack_public_path__ + "static/media/icon-present.ddb47e1447255df0e476de1625fb91ce.svg";
export { ForwardRef as ReactComponent };